import VPopoverItem from './index.vue';

export default {
  install: (Vue) => Vue.component('VPopoverItem', VPopoverItem),
};
